<template>
  <div>
    <div class="mb-2">
      <AppInputLabel :name="name" :label="label" :hasError="hasError(name).value" :required="required"></AppInputLabel>
    </div>
    <div class="control">
      <textarea :id="name" class="w-full " :class="{ 'border-critial': errors.get(name) }" :disabled="disabled"
        v-model="innerValue" :placeholder="placeholder" :maxlength="maxlength ?? 1000" @input="handleInput"
        @keyup="validateInput" @blur="validateInput" rows="5"></textarea>

    </div>
    <div class="flex justify-between items-center">
      <AppInputError v-show="hasError(name)" :error="errors.get(name)"></AppInputError>

      <AppTextLengthCounter v-if="maxlength" :maxLength="(maxlength as number)" :text="(innerValue as string)">
      </AppTextLengthCounter>
    </div>
  </div>
</template>
<script setup lang="ts">
import { inject, ref, watch, onBeforeUnmount } from "vue";
import { ValidationContextKey } from "@/models/Context";
import useFormValidation from "@/modules/useFormValidation";
import AppTextLengthCounter from "@/components/AppTextLengthCounter.vue";
import AppInputLabel from "./AppInputLabel.vue";
import AppInputError from "./AppInputError.vue";


const props = defineProps<{
  required: boolean;
  name: string;
  label: string;
  placeholder?: any;
  modelValue?: string | number | null;
  disabled?: boolean;
  maxlength?: number | string | null;
}>();

let innerValue = ref(props.modelValue);

const emit = defineEmits(["update:modelValue"]);

// Create a default validation context if none is provided
const defaultContext = {
  errors: new Map<string, string>(),
  validators: {} as Record<string, (key: string, validator: string) => void>,
  registerValidator: (key: string, validator: (key: string, validator: string) => void) => {
    defaultContext.validators[key] = validator;
  }
};

const context = inject(ValidationContextKey, defaultContext);
const { validateRequiredField, clearValidator, clearError, errors, registerValidator, hasError } = useFormValidation(context);
const control = ref();

const validateInput = () => {
  clearError(props.name);

  if (props.required) {
    validateRequiredField(props.name, props.label, innerValue.value as string);
  }
};

const handleInput = () => {
  validateInput();
  emit("update:modelValue", innerValue.value);
};

registerValidator(props.name, validateInput);

watch(
  () => props.modelValue,
  (newVal) => {
    innerValue.value = newVal;
    validateInput();
  }
);

if (props.value && props.required) {
  validateInput();
}

const focus = () => {
  control.value.focus();
};


onBeforeUnmount(() => {
  clearValidator(props.name);
  clearError(props.name);
});

defineExpose({ focus });
</script>